import { Component } from '@angular/core';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss'],
  standalone: true
})
export class TermsComponent {

  constructor() {}

  ngOnInit(): void {
  }
}
